import moment from "moment";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { getWeeklyTimesheetApi } from "../../../slices/attendanceSlice";
import Accordion from "../components/Accordion";
import DatePicker from "react-datepicker";
import ExDropdown from "../../../components/basic-components/ExDropdown";

const PendingTimesheet = () => {
  const [accordions, setAccordion] = useState(null);

  const dispatch = useAppDispatch();
  const weeklyTimesheet = useAppSelector(
    (state) => state.attendance.weeklyTimesheet
  );

  const timesheet = useAppSelector((state) => state.attendance.timesheet);
  const userId = useAppSelector((state) => state?.login?.session?.userId);
  const memberDetail = useAppSelector((state) => state.company.memberDetails);
  console.log("timesheet", weeklyTimesheet);

  const [status, setStatus] = useState({ key: "Pending", Id: 1 });
  const [selectedDate, setSelectedDate] = useState();
  const statusList = [
    { key: "Pending", Id: 1 },
    { key: "Approved", Id: 2 },
    { key: "Rejected", Id: 3 },
  ];

  useEffect(() => {
    dispatch(
      getWeeklyTimesheetApi(
        {
          reportingManager: memberDetail.id,
          status: status.key, // Use the key from the status object
        }
        // employeeId: userId,
      )
    );
  }, [dispatch, userId, status]);

  const toggleAccordion = (timesheet) => {
    if (accordions == timesheet.id) {
      setAccordion(null);
    } else {
      setAccordion(timesheet.id);
    }
  };

  return (
    <>
      <div className="">
        <div className="w-full flex items-center justify-between p-2">
          <div className="w-5/12">
            <ExDropdown
              title="" //this is used attribute for designatiion
              placeholder="Select"
              onChange={(e) => setStatus(e)}
              value={status}
              optionValue="Id"
              optionLabel="key"
              options={statusList}
              dropDownHeight="40px"
              dropDownBorderWidth="1px"
              dropDownBorderColor="#8C8C8C"
              //error={errors?.?.message}
              isMandatory={false}
              error={undefined}
            />
          </div>
          {/* <div className="w-5/12">
            <label>Select Month</label>
            <DatePicker
              className="h-10 border border-exgray-300/80 outline-none rounded-lg px-2  focus:ring-0"
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              dateFormat="MMMM YYYY"
              //excludeDates={[new Date("2024-05-01"), new Date("2024-06-01")]}
              showMonthYearPicker
              maxDate={new Date()}
            />
          </div> */}
        </div>
        <div className="p-2">
          {weeklyTimesheet?.map((timesheet) => (
            <Accordion
              key={timesheet.id}
              weeklyTimesheetId={timesheet.id}
              title={`${timesheet?.employee?.firstName} ${timesheet?.employee?.lastName}                                       `}
              data={timesheet}
              subtitle={`${moment
                .utc(timesheet.weekStartDate)
                .format("DD MMM YYYY")} - ${moment
                .utc(timesheet.weekEndDate)
                .format("DD MMM YYYY")}`}
              isOpen={timesheet.id === accordions}
              toggleAccordion={() => toggleAccordion(timesheet)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default PendingTimesheet;
